import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DialogYoutubeLightboxComponent } from 'src/app/dialogs/dialog-youtube-lightbox/dialog-youtube-lightbox.component';

@Component({
  selector: 'app-take-care',
  templateUrl: './take-care.component.html',
  styleUrls: ['./take-care.component.scss']
})
export class TakeCareComponent implements OnInit {
  videos: any;

  constructor(
    public dialog: MatDialog) { }

  ngOnInit() {
    this.videos = [
      {
        title: '¿Cómo negociar el uso del condón?',
        id: 'H0FX-TPCpV0'
      },
      {
        title: 'Métodos anticonceptivos condón femenino',
        id: 'PbibyImKMDU'
      },
      {
        title: 'Métodos anticonceptivos condón masculino',
        id: 'KJ2hCcCTwyU'
      },
      {
        title: 'Métodos anticonceptivos permanentes',
        id: 'psg9Hb9CXVI'
      },
      {
        title: '¿Por qué esperar para embarazarte?',
        id: 'Pb2IOimLi7w'
      },
      {
        title: 'Enfermedades de transmisión sexual',
        id: 'OVxjkV9Sxtg'
      },
      {
        title: 'Derechos sexuales',
        id: 'wfoTeapMeBw'
      },
      {
        title: 'Prevenir es tu derecho',
        id: 'laFbeEYrbpc'
      },
      {
        title: '¿Qué son las ITS? Una guía rápida',
        id: 'PnwMCnNsBdA'
      },
      {
        title: 'Sífilis',
        id: 'YBKB6Dusubo'
      },
      {
        title: 'Gonorrea',
        id: 'M7V8Xk0wotk'
      },
      {
        title: 'Herpes Genital',
        id: 'AtKcs3E1PU'
      },
      {
        title: 'Virus del Papiloma Humano (VPH)',
        id: 'z6gOBIu0hk4'
      },
      {
        title: 'Clamidia',
        id: '01RfKB1sP0U'
      },
      {
        title: 'Virus de inmunodeficiencia Humana (VIH)',
        id: 'J6Qk2XP9O6E'
      },
      {
        title: 'Vivir con VIH',
        id: 'r5A0MZcHuDk'
      }
    ];
  }

  openDialogVideo(index) {
    this.dialog.open(DialogYoutubeLightboxComponent, {
      disableClose: true,
      data: this.videos[index]
    });
  }
}
